import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Injector,
  input,
  output,
} from '@angular/core';

import { DateService, Store } from '@softline/core';
import { ClassRule, ClassRulePipe, DynamicModule, WithDefinition } from '@softline/dynamic';
import { SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST } from '../../arbeitsbericht.api';
import { TimeReport } from '../../models/time-report.model';
import { TimeReportsService } from '../../services/time-reports.service';
import {
  CardAccent,
  CardComponent,
  EmptyStateComponent,
  LoadingSkeletonComponent,
} from '@softline/ui-core';
@Component({
  selector: 'soft-time-report-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DynamicModule,
    CardComponent,
    EmptyStateComponent,
    LoadingSkeletonComponent] })
export class ListComponent extends WithDefinition(
  SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST
) {
  private dateService = inject(DateService);
  private timeReportService = inject(TimeReportsService);

  date = input(this.dateService.now());

  all = this.timeReportService.value;
  loading = this.timeReportService.isLoading;

  selectedChange = output<TimeReport>();

  readonly #classRule = new ClassRulePipe(inject(Injector));

  /** The definition without its green row background — the card's success accent shows that state instead. */
  readonly rowDefinition = computed(() => {
    const definition = this.definition();
    if (!definition) return definition;
    return { ...definition, class: stripSuccessBackground(definition.class) };
  });

  accentOf(item: TimeReport): CardAccent {
    const rootClass = this.definition()?.class;
    return this.#classRule.transform(rootClass, item).some(isSuccessBackground)
      ? 'success'
      : 'primary';
  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  constructor(private store: Store) {
    super();
  }
}

type RootClass = undefined | string | (string | ClassRule)[];

const isSuccessBackground = (token: string): boolean =>
  /^!?bg-(success|green)(-\d+)?$/.test(token);

const withoutSuccessBackground = (classes: string): string =>
  classes
    .split(' ')
    .filter((token) => token && !isSuccessBackground(token))
    .join(' ');

function stripSuccessBackground(rule: RootClass): RootClass {
  if (!rule) return rule;
  if (typeof rule === 'string') return withoutSuccessBackground(rule);
  return rule.map((entry) =>
    typeof entry === 'string'
      ? withoutSuccessBackground(entry)
      : { ...entry, class: withoutSuccessBackground(entry.class) }
  );
}
